<template>
    <div class="board-root h-full all-activities">
        <div class="activities-sidemenu">
            <div class="add-list">
                <div class="add-list-item">
                    <div class="list-header">
                        <div class="list-title">Projects</div>
                        <div class="show-info-btn" @click="toggleInfoModal()"></div>
                    </div>
                    <div :class="[selectedBoardId ? 'has-selected' : '', 'add-list-body']">
                        <a v-for="board in boards"
                           href="#"
                           :class="['list-filter-item', { 'active-list-filter': selectedBoardId === board.id }]"
                           @click.prevent="selectProject(board)"
                           :key="board.id"
                        >{{ board.title }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="all-activites-content">
            <div class="events-container">
                <EventsTabs
                    :events="activitiesTasks"
                    :loader="loadingActivities"
                    :getEventsTask="getEventsTask"
                    :defaultActiveTab="defaultActiveTab"
                    :openEditTask="openEditTask"
                    @activeTab="activeActivity"
                    :tags="tags"
					@getEventsTask="getEventsTask"
                >
                </EventsTabs>
            </div>
            <div class="pagination-container">
                <VButton @clickHandler="firstPage">
                    <i class="icon-backward-step"></i>
                </VButton>
                <VButton @clickHandler="prevPage" style="transform: rotate(-180deg);">
                    <i class="icon-arrow_forward_ios"></i>
                </VButton>
                <span
                    v-if="activePaginationNumbers.includes(Math.ceil(no_objects / paginate_by)) && activePaginationNumbers.length > 8"
                    @click="firstPage"
                >1 ...</span>
                <span
                    v-for="num in activePaginationNumbers"
                    :key="num"
                    @click="currentPage = num, getEventsTask()"
                    :class="[{'blue-text': num == currentPage}]"
                >{{ num }}</span>
                <span
                    v-if="!activePaginationNumbers.includes(Math.ceil(no_objects / paginate_by))"
                    @click="lastPage"
                >... {{ Math.ceil(no_objects / paginate_by) }}</span>
                <VButton @clickHandler="nextPage">
                    <i class="icon-arrow_forward_ios"></i>
                </VButton>
                <VButton @clickHandler="lastPage">
                    <i class="icon-forward-step"></i>
                </VButton>
            </div>
        </div>

            
        <div v-if="isInfoModalShown" @click.self="isInfoModalShown = false" class="smart-list-card-wrap">
            <div class="smart-list-card">
                <h3>Example use-cases:</h3>
                <p> - What happened yesterday on project Goleko.dev?<br>
                    - Find the file that Alice uploaded yesterday?<br>
                    - What files have been uploaded on project Goleko.dev?<br>
                    - What did Alice do yesterday</p>
                <p>and many more</p>
            </div>
        </div>

        <VModal class="edit-task-modal" ref="edit-task-modal" size="xl" @hideModal="closeModalEditTask" @showUploadState="showUploadState">
            <EditTask
                :task="task"
                :tags="tags"
                :allEvents="task_events"
                :getEventsTask="getEventsTask"
                :board_id_from_task="board_id_from_task"
                @hideModal="hideEditModal"
                @toggleConflictSaving="toggleConflictSaving"
				@showUploadState="showUploadState"
            />
        </VModal>

        <Flash ref="show"/>
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import EventsTabs from "@/components/molecules/EventsTabs.vue";
import Flash from "@/components/Flash.vue";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";
import VButton from "@/components/atoms/VButton.vue";
import { mapState } from 'vuex';
import EditTask from "@/components/molecules/EditTask.vue";
import VModal from "@/components/atoms/VModal.vue";

export default {
    name: 'AllActivities',
    components: { EventsTabs, Flash, LoaderAnimationVue, VButton, EditTask, VModal },
    data() {
        return {
            selectedUserId: null,
            selectedBoardId: null,
            events: [],
            task_events: [],
            loadingActivities: false,
            activeActivityTab: ['logwork', 'upload', 'comment'],
            defaultActiveTab: 'all',
            currentPage: 1,
            paginate_by: 50,
            no_objects: 0,
            task: {
                id: "",
                title: "",
                body: "",
                tags: [],
                is_template: false,
            },
            board_id_from_task: '',
            tags: [],
            activePaginationNumbers: [],
            task_board_id: null,
            isInfoModalShown: false
        }
    },
    computed: {
        boards() {
            return this.$store.getters.boards
        },
        ...mapState(['smartListFilter']),
        editableTask() {
            return this.$store.getters.editableTask
        },
        events2() {
            return this.$store.getters.events2
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        allTags() {
            return this.$store.getters.tags
        },
        activitiesTasks() {
            return this.$store.getters.activitiesTasks
        }
    },
    watch: {
        smartListFilter(newVal) {
            this.selectedUserId = newVal
            this.currentPage = 1
            this.getEventsTask()
        }
    },
    mounted() {
        this.currentPage = 1
        this.getEventsTask()
        this.tagsSearch()
    },
    methods: {
        async tagsSearch() {
            try {
                let data = {
                    paginate_by: 2000
                };

                const response = await api.post(`/tag_search`, data);

                if(response.status === 200) {
                    this.$store.dispatch('setTags', response.data.data)
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
            }
        },
        async getEventsTask() {
            try {
                const data = {
                    ...(this.selectedBoardId && {project_id: this.selectedBoardId}),
                    ...(this.selectedUserId && this.selectedUserId !== 'no-filter' && {user_id: Number(this.selectedUserId)}),
                    types: this.activeActivityTab,
                    paginate_by: this.paginate_by,
                    page: this.currentPage,
                    with_task: true
                };
                
                this.loadingActivities = true
                const response = await api.post(`/activity_search`, data);

                if (response.status === 200) {
                    this.events = response.data.data
                    this.$store.dispatch('setActivitiesTasks', response.data.data)
                    this.no_objects = response.data.totalCount
                    this.loadingActivities = false
                    this.generatePaginationNumbers()
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || 'Something went wrong');
                this.loadingActivities = false
            }
        },
        getTaskEvents(task) {
            this.task_events = this.events2.filter(e => {
                return e.task_id == task.id
            })
        },
        activeActivity(val) {
            if (val == 'comment') {
                this.activeActivityTab = ['comment']
                this.defaultActiveTab = 'comment'
            } else if (val == 'files') {
                this.activeActivityTab = ['upload']
                this.defaultActiveTab = 'files'
            } else if (val == 'logs') {
                this.activeActivityTab = ['logwork']
                this.defaultActiveTab = 'logs'
            } else {
                this.activeActivityTab = ['logwork', 'upload', 'comment']
                this.defaultActiveTab = 'all'
            }
            this.currentPage = 1
            this.getEventsTask()
        },
        firstPage() {
            if (this.currentPage === 1) {
                this.$refs.show.showFlashWarning('You are already in the first page');
            } else {
                this.currentPage = 1
                this.getEventsTask()
            }
        },
        prevPage() {
            if (this.currentPage === 1) {
                this.$refs.show.showFlashWarning('You are already in the lowest page');
            } else {
                this.currentPage--
                this.getEventsTask()
            }
        },
        nextPage() {
            if (this.paginate_by * this.currentPage >= this.no_objects) {
                this.$refs.show.showFlashWarning('No more activities to show');
            } else {
                this.currentPage++
                this.getEventsTask()
            }
        },
        lastPage() {
            if (this.paginate_by * this.currentPage >= this.no_objects) {
                this.$refs.show.showFlashWarning('You are already in the last page');
            } else {
                this.currentPage = Math.ceil(this.no_objects / this.paginate_by)
                this.getEventsTask()
            }
        },
        generatePaginationNumbers() {
            const firstNumberInGroup = Math.floor((this.currentPage - 1) / 8) * 8 + 1;
            const lastNumberInGroup = Math.min(firstNumberInGroup + 7, Math.ceil(this.no_objects / this.paginate_by));
            
            let array = Array.from({ length: Math.min(8, lastNumberInGroup - firstNumberInGroup + 1) }, (_, index) => firstNumberInGroup + index);
            if (array.length == 1 && array[0] !== 1) {
                array = []
                for (let i = this.currentPage - 8; i <= this.currentPage; i++) {
                    array.push(i);
                }
            }

            const lastArrayNum = array[array.length - 1]
            if (lastArrayNum + 1 == Math.ceil(this.no_objects / this.paginate_by)) {
                array.push(lastArrayNum + 1)
            }

            this.activePaginationNumbers = array;
        },
        formattedTask(task) {
            const allUsers = this.boards.flatMap(board => board.members).filter(user => user)
            const usersMap = new Map(allUsers.map(user => [user?.id, user]))
            const tagMap = new Map(this.allTags.map(tag => [tag?.id, tag]))
            
            let tags = null;
            if(typeof task.tags == 'string') {
                tags = task.tags.split('|')
                        .filter(tag => tag.trim() !== '')
                        .map(tag => {
                            let t = tag.split(':')
                            return {
                                tagType: t[0],
                                id: Number(t[1])
                            }
                        })
                        .filter(tag => tag.id)
                        .map(tag => {
                            if(tag.tagType == 'user') {
                                return {
                                    tagType: tag.tagType,
                                    ...usersMap.get(tag.id)
                                }
                            }
                            if(tag.tagType == 'tag') {
                                return {
                                    tagType: tag.tagType,
                                    ...tagMap.get(tag.id)
                                }
                            }
                        })
                } else if(typeof task.tags == 'array' || (typeof task.tags == 'object' && task.tags && typeof task.tags[0] == 'string')) {
                    tags = task.tags
                            .map(tag => {
                                let t = tag.split(':')
                                return {
                                    tagType: t[0],
                                    id: Number(t[1])
                                }
                            })
                            .filter(tag => tag.id)
                            .map(tag => {
                                if(tag.tagType == 'user') {
                                    return {
                                        tagType: tag.tagType,
                                        ...usersMap.get(tag.id)
                                    }
                                }
                                if(tag.tagType == 'tag') {
                                    return {
                                        tagType: tag.tagType,
                                        ...tagMap.get(tag.id)
                                    }
                                }
                            })
                } else if(typeof task.tags == 'object' && task.tags && typeof task.tags[0] == 'object') {
                    tags = task.tags
                } else {
                    tags = []
                }

            const updatedTask = {
                ...task,
                tags: tags
            }

            return updatedTask
        },
        openEditTask(item) {
            this.task = this.formattedTask(JSON.parse(JSON.stringify(item)))
            this.$store.dispatch('setEditableTask', this.task);

            this.board_id_from_task = item.project_id

            const board = this.boards.filter(board => board.id == item.project_id)
            this.getTags()

            this.$refs['edit-task-modal'].showModal()

            var newURLSegment = `/app/tasks/${this.titleToSlug(item.title)}-${item.id}`;
            var currentState = history.state || {};
            currentState.urlSegment = newURLSegment;
            history.pushState(currentState, '', newURLSegment);

            this.task_board_id = this.task.project_id
            this.getTaskEvents(this.task.id)
        },
        getTags() {
            if (!this.activeBoard) return
            if (this.board_id && this.boards && !this.from_task) {
                const currentBoard = this.activeBoard
                this.tags = currentBoard && currentBoard?.members
            } else {
                const currentBoard = this.activeBoard
                this.tags = currentBoard && currentBoard?.members
            }
        },
        hideEditModal() {
            this.$refs['edit-task-modal'].hideModal();
        },
        toggleConflictSaving(mode) {
            if (mode == 'show') {
                this.$refs['conflict-saving'].$refs['conflict-saving'].showModal()
            } else {
                this.$refs['conflict-saving'].$refs['conflict-saving'].hideModal()
            }
        },
        async closeModalEditTask() {
            var newURLSegment = `/app/all-activities`;
            var currentState = history.state || {};
            currentState.urlSegment = newURLSegment;
            history.pushState(currentState, '', newURLSegment);
        },
        titleToSlug(title) {
            let slug = title.toLowerCase();

            slug = slug.replace(/\s+/g, '-');
            slug = slug.replace(/[^a-z0-9\-]/g, '');
            slug = slug.replace(/-+/g, '-');
            slug = slug.replace(/^-+|-+$/g, '');

            return slug;
        },
        toggleInfoModal() {
            this.isInfoModalShown = !this.isInfoModalShown;
        },
        showUploadState(files, taskID) {
            console.log('showUploadState all activities')
            this.$emit('showUploadState', files, taskID)
        },
        selectProject(board) {
            if(this.selectedBoardId !== board.id) {
                this.selectedBoardId = board.id
                this.$store.dispatch('setActivitiesSelectedBoard', board)
            } else {
                this.selectedBoardId = null
                this.$store.dispatch('setActivitiesSelectedBoard', null)
            }
            
            this.currentPage = 1
            this.getEventsTask()
        }
    },
    destroyed() {
        this.$store.dispatch('setActivitiesTasks', [])
    }
}
</script>

<style lang="scss">
.all-activities {
    display: flex;
    align-items: flex-start;
    justify-content: stretch;
    overflow: hidden;

    .activities-sidemenu {
        display: flex;
        flex-direction: column;
        max-height: 99%;
    }

    .add-list {
        background-color: var(--primary-bg);
        margin-top: 12px;
        margin-left: 12px;
        overflow-y: auto;
        padding: 0;
        min-width: 180px;
        max-height: 400px;
        position: relative;
        z-index: 1;
        max-height: calc(100% - 24px);
        width: 95%;
        min-height: 90px;

        .list-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #454545;
            padding: 6px 6px 6px 15px;
        }

        .add-list-body {
            padding: 15px 6px;

            &.has-selected {
                .list-filter-item {
                    @include media-down(md) {
                        display: none;
                    }

                    &.active-list-filter {
                        display: block;
                    }
                }
            }
        }

        .list-filter-item {
            display: block;
            font-size: 16px;
            font-weight: 500;
            word-break: break-word;
            border-radius: 10px;
            padding: 4px 7px;
            min-height: 30px;

            &:last-child {
                margin-bottom: 0;
            }

            &:hover {
                background-color: var(--hover);
                color: var(--primary-text);
            }

            &.active-list-filter {
                background-color: var(--accent);
                color: #fff;
            }
        }
    }

    .smart-list-card-wrap {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        z-index: 10;
        background: var(--prymary-bg);
        backdrop-filter: blur(0px);
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        width: 100%;
        border-radius: unset;
        transform: translateX(0);
        .smart-list-card {
            max-width: 600px;
            max-height: 600px;
            height: fit-content;
            margin: 0 20px;
            padding-top: 20px;
        }
        p {
            font-size: 17.2px;
            margin-bottom: 15px;
        }
        h3 {
            margin-bottom: 15px;
        }
        .smart-list-video {
            margin-top: 15px;
            max-height: 250px;
        }
    }

    .all-activites-content {
        height: 100%;
        flex: 1;
        padding: 15px 10px;

        .loading-activities {
            font-size: 25px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            min-height: 100px;
            padding: 0 20px;
            color: #fff;
        }

        .all-activities-wrap {
            flex-direction: row-reverse;
        }

        .events-container {
            height: 95%;
            overflow-y: auto;

            .btn.light-blue.active {
                background-color: $new-blue;
            }

            .title-wrap {
                margin: 0;
            }
        }

        .pagination-container {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            margin-top: 5px;
            font-weight: 500;
            color: #fff;
            padding-top: 3px;
            padding-bottom: 3px;
            min-height: 34px;
            span {
                cursor: pointer;
                user-select: none;

                &.blue-text {
                    color: #00a3ff;
                }
            }
            a.btn {
                max-width: 20px;
                min-height: 20px;
                border-radius: 10px;
                background: #36434E;
                &:hover {
                    background: #454c53;
                }
            }
            i {
                font-size: 7px;
            }
        }
    }
}
</style>
